@use "stylesheets/utility/variables";

.logoLink {
  &:hover {
    background-color: transparent;
  }
}

.headerLogo {
  display: flex;
  @media (max-width: variables.$laptop) {
    padding-left: 8px;
  }
}
